import React from "react";
import SectionRowLayout, { InfoSide } from './../../../shared/components/SectionRowLayout';
import DynamicElement from 'shared/components/DynamicElement';
import {
  withStyles,
  withWidth,
} from "@material-ui/core";
import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const styles = (theme) => ({

});

const AboutSection = React.forwardRef((props, ref) => {
  const { noHeightStretch, bigImage, smallTitle, bigTitle, description, smallImage, className } = props;
  return (
    <div id={props.id} style={{ backgroundColor: "#FFFFFF", position: 'relative', height: noHeightStretch ? 'auto' : '100vh', display: 'flex' }} ref={ref} className={className}>

      <div className="container-fluid" style={{ margin: 'auto', paddingTop: 128, paddingBottom: 128 }}>

        <SectionRowLayout
          bigImage={bigImage}
          smallTitle={
            <DynamicElement id={smallTitle}>
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          }
          bigTitle={
            <DynamicElement id={bigTitle}>
              {({ value }) => <div dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          }
          description={
            <DynamicElement id={description}>
              {({ value }) => <p dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          }
          smallImage={smallImage}
        />
      </div>

    </div>
  );
});

const MobileWrapper = styled.div`
  background-color: white;
  max-width: 100%;
  padding: 0;
  img{
    object-fit: cover;
    width: 100%;
    padding: 24px;
    padding-top: 30px;
  }
`;

const SectionWrapper = (props) => {
  const { noHeightStretch, bigImage, smallTitle, bigTitle, description, smallImage } = props;
  if (props.width === 'xs') {
    return <MobileWrapper className="dark-support">
      <DynamicElement id={bigImage}>
        {({ value }) =>
          <LazyLoadImage style={{ maxWidth: "100%", height: 'auto', position: 'relative' }} src={value} />
        }
      </DynamicElement>
      <InfoSide 
        infoSideStyle={{padding: 24}}
        sectionLineTitleStyle={{textAlign: 'right', marginTop: 10, marginBottom: -10}}
        smallTitle={
          <DynamicElement id={smallTitle}>
            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        }
        bigTitle={
          <DynamicElement id={bigTitle}>
            {({ value }) => <div dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        }
        bigTitleStyle={{fontSize: 55, textAlign: 'center'}}
        diamondIconStyle={{ 
          marginTop: 30,
          left: 'calc(50% - 40px)'
        }}
        description={
          <DynamicElement id={description}>
            {({ value }) => <p dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        }
        descriptionStyle={{padding: 0, paddingRight: 0, textAlign: 'center'}}
        descriptionXs={12}
        smallImage={smallImage}
        smallImageStyle={{padding: 30, paddingTop: 0, marginTop: -30}}
      />
    </MobileWrapper>
  } else {
    return <AboutSection {...props} className="dark-support" />
  }
}

export default React.memo(withWidth()(withStyles(styles, { withTheme: true })(SectionWrapper)));
